export const CARD_TYPE_MAP = {
  VISA: 'visa',
  MASTERCARD: 'master-card',
  AMEX: 'american-express',
  DISCOVER: 'discover',
  CHQ: 'direct-debit', // Example for Direct Debit
  SAV: 'direct-debit', // Example for Savings Account
};

export const PAYMENT_METHODS = [
  {
    id: 65478962002,
    label: 'Paymentus',
    value: 'paymetus',
    activeIcon: require('./assets/images/paymentus.png'),
    inActiveIcon: require('./assets/images/paymentus.png'),
  },
  {
    id: 65478962001,
    label: 'Ippay',
    value: 'ippay',
    activeIcon: require('./assets/images/ippay.png'),
    inActiveIcon: require('./assets/images/ippay.png'),
  },
  {
    id: 65478962003,
    label: 'Elavon',
    value: 'elavon',
    activeIcon: require('./assets/images/elavon.png'),
    inActiveIcon: require('./assets/images/elavon.png'),
  },
  {
    id: 65478962004,
    label: 'Global Payments',
    value: 'global_payment',
    activeIcon: require('./assets/images/global_pay.png'),
    inActiveIcon: require('./assets/images/global_pay.png'),
  },
];

export const PAYMENT_OPTIONS = [
  {
    id: 78956423,
    value: 'american-express',
    icon: require('./assets/images/american-express.png'),
  },
  {
    id: 78956424,
    value: 'discover',
    icon: require('./assets/images/discover.png'),
  },
  {
    id: 78956426,
    value: 'master-card',
    icon: require('./assets/images/master-card.png'),
  },
  {
    id: 78956427,
    value: 'visa',
    icon: require('./assets/images/visa.png'),
  },
];

export const PaymentTransactionData = {
  subscriberId: '92380051599', // string
  payment: {
    header: {
      operation: '', // string
      'account-number': '', // string
      'account-token': '', // string
      'payment-amount': '', // string
      'payment-type-code': '', // string
      'check-duplicates': '', // string
    },
    'payment-method': {
      token: '', // string
    },
    customer: {
      'first-name': '', // string
      'middle-name': '', // string
      'last-name': '', // string
      'day-phone-nr': '', // string
      email: '', // string
      address: {
        line1: '', // string
        state: '', // string
        'zip-code': '', // string
        city: '', // string
        country: '', // string
      },
    },
  },
};

// Example of creating a new PaymentTransactionData instance
//const transaction = new PaymentTransactionData('subscriberId123', payment);

export const SidebarItem = {
  id: 0,
  title: '',
  icon: undefined,
  count: undefined,
  route: undefined,
  active: undefined,
  text: undefined,
  visible: undefined,
};

// GlobalState structure
export const GlobalState = {
  loader: false,
  customerData: null,
  chatBotConfig: null,
  weatherData: null,
  sidebarActive: SidebarItem,
  showCreateTicket: false,
  innerPage: { id: 0, title: '' },
  chatbotExpanded: false,
  selectedSubscriberData: null,
  menuItems: null,
  loggedInDetails: null,
  accessTokenStatus: false,
  isLoggedIn: false,
  isAuth: false,
};

// Option structure
export const Option = {
  label: '',
  value: '',
};

// InnerPage structure
export const InnerPage = {
  id: 0,
  title: '',
};

// UsagePayload structure
export const UsagePayload = {
  source: undefined,
  client: undefined,
  accessToken: undefined,
  provider: undefined,
  granularity: undefined,
  startTime: undefined,
  subscriberLocationId: undefined,
  endTime: undefined,
};

// UpgradeServicePayload structure
export const UpgradeServicePayload = {
  subscriberId: undefined,
  serviceId: undefined,
};

// UpgradeServicePlanPayload structure
export const UpgradeServicePlanPayload = {
  subscriberId: undefined,
};

// InvoiceDeliveyPayload structure
export const InvoiceDeliveyPayload = {
  subscriberId: undefined,
};

// OutageAlertPayload structure
export const OutageAlertPayload = {
  status: undefined,
  companyName: undefined,
  subscriberAccount: undefined,
};

// EditProfilePayload structure
export const EditProfilePayload = {
  subscriberId: undefined,
  personId: undefined,
  personFirstName: undefined,
  personLastName: undefined,
  personMiddleName: undefined,
};

// AdditionalContactPayload structure
export const AdditionalContactPayload = {
  subscriberId: undefined,
  contactType: undefined,
  phoneNumber: undefined,
  phoneExtension: undefined,
  emailAddress: undefined,
  primaryContact: undefined,
  allowMarketing: undefined,
  allowThirdPartyMarketing: undefined,
};

// DeleteAdditionalContactPayload structure
export const DeleteAdditionalContactPayload = {
  subscriberId: undefined,
  contactId: undefined,
};

// SecurityPinPayload structure
export const SecurityPinPayload = {
  subscriberId: undefined,
  securityPIN: undefined,
};

// NotificationStatusPayload structure
export const NotificationStatusPayload = {
  subscriberId: undefined,
  deviceToken: undefined,
};

// CustomerPayload structure
export const CustomerPayload = {
  customerName: undefined,
};

// GuarantorPayload structure
export const GuarantorPayload = {
  subscriberId: undefined,
  guarantorId: undefined,
};

// QueryTableName structure
export const QueryTableName = {
  tableName: undefined,
};

// UploadProfilePayload structure
export const UploadProfilePayload = {
  subscriberId: '',
  companyId: '',
};

// GuarantorUpdateData structure
export const GuarantorUpdateData = {
  guarantorType: null,
  subscriberId: '',
  guarantorId: '',
  noChecks: false,
  noCreditCards: false,
  creditClass: '',
  addressLine1: '',
  addressLine2: '',
  addressLine3: '',
  firstName: '',
  lastName: '',
  email: '',
  autoPayMethod: '',
  phoneNumber: '',
  jobTitle: undefined,
  monthsEmployed: undefined,
  selfEmployed: undefined,
  employerContactName: undefined,
  employerPhoneNumber: undefined,
  employerEmailAddress: undefined,
  employerAddressName: undefined,
  employerAddressLine1: undefined,
  employerAddressLine2: undefined,
  employerAddressCity: undefined,
  employerStateProvId: undefined,
  employerPostalCode: undefined,
  employerCountryId: undefined,
  residenceOwnOrRent: undefined,
  residenceMonths: undefined,
  landlordName: undefined,
  landlordContactName: undefined,
  landlordPhoneNumber: undefined,
  landlordEmailAddress: undefined,
  eftAccountType: '',
  eftAuthNameStart: '',
  eftAuthNameEnd: '',
  eftAccountFirstName: '',
  eftAccountLastName: '',
  eftAccountMiddleInit: undefined,
  eftAccountOrgName: undefined,
  eftBankPhoneNumber: '',
  eftCreditCardBrand: '',
  eftCreditCardNumber: '',
  eftCreditCardExpiration: '',
  eftExternalAccountToken: '',
  eftBankAuthMethod: '',
};

// GuarantorAddPaymentData structure
export const GuarantorAddPaymentData = {
  subscriberId: '',
  guarantorId: '',
  profileId: '',
  paymentAmount: undefined,
};
